"use client"

import React, { useEffect } from "react"
import { cn } from "../lib/utils"
import { getSiteIdFromHost } from "../sites/config"
import { stripStrayBr } from "../utils/strip-stray-br"
import ContentLightbox from "./content-lightbox.client"

interface NormalContentProps {
  content?: string
  tableOfContents: Array<{ id: string; title: string }>
  className?: string
}

const NormalContent: React.FC<NormalContentProps> = ({ content, tableOfContents, className }) => {
  if (!content) return null

  const isTamdaMedia = getSiteIdFromHost() === "tamdamedia.eu"

  let modifiedContent = stripStrayBr(content)
  let index = 0
  modifiedContent = modifiedContent.replace(/<h([2-5])>/g, (match, p1) => {
    const tocItem = tableOfContents[index] || { id: `section-${index + 1}` }
    index += 1
    return `<h${p1} id="${tocItem.id}">`
  })

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          const element = entry.target as HTMLElement
          if (entry.isIntersecting) {
            document.querySelector(`[href="#${element.id}"]`)?.classList.add("active")
          } else {
            document.querySelector(`[href="#${element.id}"]`)?.classList.remove("active")
          }
        })
      },
      {
        rootMargin: "-20% 0px -80% 0px",
      },
    )

    tableOfContents.forEach(({ id }) => {
      const element = document.getElementById(id)
      if (element) {
        observer.observe(element)
      }
    })

    return () => {
      tableOfContents.forEach(({ id }) => {
        const element = document.getElementById(id)
        if (element) {
          observer.unobserve(element)
        }
      })
    }
  }, [tableOfContents])

  return (
    <>
      <ContentLightbox />
      <div
        dangerouslySetInnerHTML={{ __html: modifiedContent }}
        className={cn(
          `text-[22px] content-wrapper text-[#31343e]${isTamdaMedia ? " tamda-media-lato" : ""}`,
          className,
        )}
      />
    </>
  )
}

export default NormalContent
